/**
 * HiddenToggle — circular button between the two rows of a pair.
 * Arrow indicates the direction the cover rectangle will slide on click.
 * Positioned to the LEFT of the pair group.
 */

import React from 'react';

interface HiddenToggleProps {
  hiddenIndex: 0 | 1;
  pairIndex: number;
  onClick: () => void;
}

const HiddenToggle: React.FC<HiddenToggleProps> = ({ hiddenIndex, pairIndex, onClick }) => {
  // Arrow shows direction the cover WILL slide on click:
  // hidden=0 (top covered) → click slides cover down → ↓
  // hidden=1 (bottom covered) → click slides cover up → ↑
  const arrow = hiddenIndex === 0 ? '↓' : '↑';

  // Cover color hint: orange for hint pairs (0-1), teal for guess pair (2)
  const coverColor = pairIndex === 2 ? '#1f7d7e' : '#d26f28';

  return (
    <button
      onClick={onClick}
      title={`Hidden: ${hiddenIndex === 0 ? 'top' : 'bottom'} — click to swap`}
      style={{
        width: 28,
        height: 28,
        borderRadius: '50%',
        border: `2px solid ${coverColor}`,
        background: '#262626',
        color: '#f7e5c5',
        fontSize: 12,
        fontWeight: 700,
        fontFamily: 'Inter, sans-serif',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 0,
        position: 'absolute',
        left: -7,
        top: '50%',
        transform: 'translateY(-50%)',
        zIndex: 5,
      }}
    >
      {arrow}
    </button>
  );
};

export default React.memo(HiddenToggle);
